import React, { useState, useEffect } from 'react';
import { API_BASE } from '../App';

const CreateChangeRequest = ({ user, token, onBack }) => {
  const [assignedProducts, setAssignedProducts] = useState([]);
  const [formData, setFormData] = useState({
    product_id: '',
    title: '',
    description: '',
    priority: 'normal'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchAssignedProducts();
  }, []);

  const fetchAssignedProducts = async () => {
    try {
      const response = await fetch(`${API_BASE}/my-assigned-products`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setAssignedProducts(data);
      }
    } catch (error) {
      console.error('Ürünler yüklenirken hata:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          type: 'degisim',
          title: formData.title,
          description: formData.description,
          priority: formData.priority,
          product_id: formData.product_id || null
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Değişim talebi başarıyla oluşturuldu!');
        setFormData({ product_id: '', title: '', description: '', priority: 'normal' });
        setTimeout(() => onBack(), 2000);
      } else {
        setMessage(data.error || 'Hata oluştu');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="form-container">
        <button onClick={onBack} className="btn-back">Geri Dön</button>
        <h2>🔄 Değişim Talebi</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>İlgili Ürün (İsteğe Bağlı):</label>
            <select
              value={formData.product_id}
              onChange={(e) => setFormData({...formData, product_id: e.target.value})}
            >
              <option value="">Ürün seçin...</option>
              {assignedProducts.map(product => (
                <option key={product.id} value={product.id}>
                  {product.product_name} ({product.serial_code})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label>Talep Başlığı:</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required
              placeholder="Değişim talebinizi kısaca özetleyin"
            />
          </div>
          
          <div className="form-group">
            <label>Talep Detayı:</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
              rows="6"
              placeholder="Değişim talebinizi detaylı olarak açıklayın..."
            />
          </div>
          
          <div className="form-group">
            <label>Öncelik:</label>
            <select
              value={formData.priority}
              onChange={(e) => setFormData({...formData, priority: e.target.value})}
            >
              <option value="low">Düşük</option>
              <option value="normal">Normal</option>
              <option value="high">Yüksek</option>
              <option value="urgent">Acil</option>
            </select>
          </div>
          
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Gönderiliyor...' : 'Değişim Talebi Oluştur'}
          </button>
        </form>
        
        {message && (
          <div className={`message ${message.includes('başarı') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateChangeRequest;